import type { selectedHistoryType, selectedFriend } from '@/views/user-chat/types'
import { defineStore } from 'pinia'

export const useChatStore = defineStore('user-chat', {
  // persist: true,
  state: () => ({
    selectedFriend: {} as selectedFriend,
    selectedHistory: {} as selectedHistoryType,
    isRecieveNewMessage: false as boolean
  }),
  getters: {
    getFriendInfo: (state) => state.selectedFriend,
    getSelectedHistory: (state) => state.selectedHistory,
    getIsRecieveNewMessage: (state) => state.isRecieveNewMessage
  },
  actions: {
    setFriendInfo(payload: selectedFriend) {
      this.selectedFriend = {
        ...this.selectedFriend,
        ...payload
      }
    },
    purgeFriendInfo() {
      this.selectedFriend = {} as selectedFriend
    },
    setSelectedHistory(payload: selectedHistoryType) {
      this.selectedHistory = {
        ...this.selectedHistory,
        ...payload
      }
    },
    setIsRecieveNewMessage(payload: boolean) {
      this.isRecieveNewMessage = payload
    }
  }
})
